import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf7.png';

const EpsStep4 = ({ previousShownErrors }) => (
  <BannerLayout
    section="FEEDBACK"
    subSection="EPS"
    previousShownErrors={previousShownErrors}
    alertText="Your net profit was not enough."
    subTitle="Research &amp; Investigate"
    paragraph1={(
      <Fragment>
        In terms of improving your company's EPS, there are only 3 ways:<br />
        <ul>
          <li>Option 1: You increase the numerator (net income)</li>
          <li>Option 2: You decrease the denominator (total shares)</li>
          <li>Option 3: You do both</li>
        </ul>
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        To better understand how to drive each of these levers, we highly recommend
        that you review your Team Report, starting with the financial statement section
        (Income Statement) and financing analysis section (Shares).
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default EpsStep4;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/eps/step4.js